exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "a.authorLink-1b63947d,a.authorLink-1b63947d:visited{color:#333}@media screen and (max-width: 500px){.collapse-dc1e6a25{display:none !important}}\n", ""]);

// Exports
exports.locals = {
	"authorLink": "authorLink-1b63947d",
	"collapse": "collapse-dc1e6a25"
};